import { render, staticRenderFns } from "./HuggyDetailsDialog.vue?vue&type=template&id=8194a55e"
import script from "./HuggyDetailsDialog.vue?vue&type=script&lang=js"
export * from "./HuggyDetailsDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports